import _extends from 'babel-runtime/helpers/extends';

import { Navbar, AppMain, Sidebar } from './components';
import { mapGetters } from 'vuex';

export default {
  name: 'AddressBookLayout',

  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapGetters(['addressBookRouters'])),

  methods: {
    navClick: function navClick(index) {}
  }
};